import request from '@/router/axios'
import store from '@/store'

const appKey = "lab"

/**
 * 用户名+密码登录
 * @param username 用户名
 * @param password 密码
 */
export const loginByUsername = (username, password) => request('/api/auth/jwt/token', {
    data: {
        username,
        password,
        app: appKey
    }
}, 'post')

/**
 * 微信登录
 * @param code
 */
export function loginByWechat(code) {
    return request('/api/auth/jwt/token/wechat', {
        data: {
            code,
            app: appKey
        }
    }, "post")
}

/**
 * 登录实验空间用户
 * @param {*} shenbaoId 申报项目ID。该项目必须完整配置对接信息（APPID、SECRET）
 * @param {*} username 用户名
 * @param {*} pass 密码
 */
export const loginByShenbao = (shenbaoId, username, pass) => {
    return request(`/api/shenbao/shenbaouser/login/${shenbaoId}`, {
        data: {
            username,
            pass
        }
    }, 'post')
}

/**
 * 退出登录
 */
export const logout = () => request('/api/auth/jwt/logout', null, 'post')

/**
 * 验证token
 */
export const verify = () => {
    return request('/api/auth/jwt/verify', {
        params: {
            token: store.getters.token
        }
    })
}

/**
 * 用户名+密码，获取云课时间用户信息
 * @param data
 * @param data.username
 * @param data.password
 */
export function checkoutWincourseUser(data = {}) {
    return request('/api/auth/jwt/wincourse/checkout', {
        data
    }, 'post')
}

/**
 * 绑定云课时间用户
 * @param wToken 云课时间用户校验时返回的token
 */
export function bindWincourseUser(wToken) {
    if (wToken == null || wToken === '') {
        return Promise.reject(new Error("参数错误，请检查！"))
    }

    return request('/api/auth/jwt/wincourse/bindUser', {
        data: {
            token: wToken
        }
    }, 'post').then((res)=>{
        // 修改当前登录用户的微信绑定状态
        store.dispatch("GetUserInfo")
        return res
    })
}

/**
 * 判断是否绑定云课时间用户
 * @param courseId
 */
export function isBindWincourseUser(courseId) {
    return request('/api/auth/jwt/wincourse/bind', {
        params: {
            courseId
        }
    })
}

/**
 * 云课时间用户注册与绑定
 * @param data
 * @param data.username 用户名
 * @param data.realname 姓名
 * @param data.password 加密后的密码
 * @param data.avatar 头像
 * @param data.birthday 生日
 * @param data.sex 性别 1男 2女
 * @param data.email 邮箱
 * @param data.telephone 手机号
 * @param data.departNames 部门，多个用逗号分隔
 * @param data.workNo 工号
 * @param data.post 职位
 * @param data.roleName 角色名称
 */
export function registerAndBindWincourseUser(data = {}) {
    return request('/api/auth/jwt/register/wincourse', {
        data
    }, 'post').then(res => {
        // 修改当前登录用户的微信绑定状态
        store.dispatch("GetUserInfo")
        return res
    })
}

export function getWincourseTicket(courseId) {
    if (courseId == null || courseId === '') {
        return Promise.reject(new Error("courseId is null"))
    }
    return request('/api/auth/jwt/wincourse/ticket', {
        params: {
            courseId
        }
    }, 'post')
}

export const getStartupUrl = data => request('/api/auth/jwt/startupUrl', {data}, 'post')

/**解析ticket */

export const verifyTicket = (ticket) => request('/api/auth/jwt/ticket/verify', {
    params: {
        ticket: ticket
    }
})
